<template>
  <div
    class="response-feedback-popup-container"
  >
    <div class="response-feedback-popup">
      <h5>Thank you!</h5>
      <span>Your feedback helps us improve our AI and more.</span>
      <div class="response-feedback-popup-actions">
        <button @click="emit('shareMoreFeedback')">
          Share more feedback
        </button>
        <button @click="emit('close')">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(["shareMoreFeedback", "close"]);
</script>

<style scoped>
.response-feedback-popup-container{--color-blue-500:#1850c1;--color-text-secondary:#616161;background:var(--color-white,#fff);border:1px solid var(--color-border-light,#d3d3d3);border-radius:var(--border-radius-md,8px);box-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 0 5px 0 rgba(0,0,0,.12);padding:10.5px;width:264px}.response-feedback-popup{display:flex;flex-direction:column;gap:7px}.response-feedback-popup h5{font-family:Inter;font-size:16px;font-weight:700;line-height:19px;margin:0}.response-feedback-popup span{color:var(--color-text-secondary);font-family:Inter;font-size:16px;font-style:normal;font-weight:400;line-height:22px}.response-feedback-popup-actions{align-items:center;display:flex;gap:24px}.response-feedback-popup-actions button{background:transparent;border:none;color:var(--color-blue-500);cursor:pointer;font-size:16px;font-weight:400;line-height:22px;padding:0}
</style>
